export default "__VITE_ASSET__ccaa30d9__"